import { render, staticRenderFns } from "./DefaultCreate.vue?vue&type=template&id=241338e1"
import script from "./DefaultCreate.vue?vue&type=script&lang=js"
export * from "./DefaultCreate.vue?vue&type=script&lang=js"
import style0 from "./DefaultCreate.vue?vue&type=style&index=0&id=241338e1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports